// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Form = require("./Form.bs.js");
let React = require("react");
let IconV5 = require("./IconV5.bs.js");
let DragDrop = require("../../../reason/settings/components/dragDrop/DragDrop.bs.js");
let ReactDnd = require("../../../reason/bindings/ReactDnd.bs.js");
let Belt_Array = require("@rescript/runtime/lib/js/Belt_Array.js");
let View__Jsx3 = require("../../../uikit/reason/helpers/View__Jsx3.bs.js");
let Attachments = require("../../../reason/common/Attachments/Attachments.bs.js");
let Belt_Option = require("@rescript/runtime/lib/js/Belt_Option.js");
let Stdlib_List = require("@rescript/runtime/lib/js/Stdlib_List.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let AttachmentFormUtils = require("../attachments/AttachmentFormUtils.bs.js");
let InitialUploadPrompt = require("../../../reason/settings/components/avatarField/InitialUploadPrompt.bs.js");
let UploadProgressIndicator = require("../../../components/NewProperty/NewPropertyAttachments/UploadProgressIndicator.bs.js");
let AttachmentFormSection__FileInputLink = require("./AttachmentFormSection__FileInputLink.bs.js");

function AttachmentFormSection$Ui$UploadList(props) {
  let bgClass = props.isImage ? "bg-zinc-50" : "bg-zinc-100";
  let paddingClass = props.hasContent ? "p-2.5" : "p-0";
  return JsxRuntime.jsx("ul", {
    children: props.children,
    className: "flex flex-wrap items-stretch " + paddingClass + " " + bgClass
  });
}

function AttachmentFormSection$Ui$UploadStatusItem(props) {
  let style_opacity = props.opacity.toString();
  let style = {
    opacity: style_opacity
  };
  return JsxRuntime.jsx("li", {
    children: props.children,
    ref: props.innerRef,
    className: "w-1/3 max-sm:w-1/2",
    style: style
  });
}

function AttachmentFormSection$Ui$UploadStatusItemInner(props) {
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: "relative h-0 pb-[95%]"
  });
}

function AttachmentFormSection$Ui$FileBarWrapper(props) {
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: "flex items-center p-2.5 max-sm:p-[5px] max-sm:text-[12px]"
  });
}

function AttachmentFormSection$Ui$FileNameWrapper(props) {
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: "flex flex-grow overflow-hidden pr-[5px] text-zinc-700"
  });
}

function AttachmentFormSection$Ui$FileOrder(props) {
  return JsxRuntime.jsx("span", {
    children: props.children,
    className: "mr-1 font-bold"
  });
}

function AttachmentFormSection$Ui$RemoveButtonWrapper(props) {
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: "flex h-[30px] w-[30px] shrink-0 items-center justify-center rounded-[3px] border border-zinc-300 text-zinc-600 transition hover:border-tan-blue-500 hover:bg-tan-blue-500 hover:text-white max-sm:h-[26px] max-sm:w-[26px] max-sm:text-base cursor-pointer",
    onClick: props.onClick
  });
}

function AttachmentFormSection$Ui$FileName(props) {
  return JsxRuntime.jsx("span", {
    children: props.children,
    className: "overflow-hidden text-ellipsis whitespace-nowrap"
  });
}

function AttachmentFormSection$Ui$AttachmentItemContent(props) {
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: "relative flex flex-1 items-center justify-center overflow-hidden"
  });
}

function AttachmentFormSection$Ui$ErrorContent(props) {
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: "flex flex-col items-center text-tan-error-500"
  });
}

function AttachmentFormSection$Ui$ErrorContentTitle(props) {
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: "px-[15px] text-center text-[11px] font-medium max-sm:hidden"
  });
}

function AttachmentFormSection$Ui$ImageContent(props) {
  return JsxRuntime.jsx("img", {
    className: "absolute inset-0 h-full w-full object-cover",
    alt: props.alt,
    src: props.src
  });
}

function AttachmentFormSection$Ui$UploadIndicatorWrapper(props) {
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: "absolute right-[20px] top-[20px] z-10 h-[30px] w-[30px]"
  });
}

function AttachmentFormSection$Ui$AttachmentItem(props) {
  let uploaded = props.uploaded;
  let dragClass = props.draggable ? " cursor-move" + (
      uploaded ? " hover:-translate-y-[5px]" : ""
    ) : "";
  let style_opacity = uploaded ? "1" : "0.33";
  let style = {
    opacity: style_opacity
  };
  return JsxRuntime.jsx("div", {
    children: Belt_Option.getWithDefault(props.children, null),
    className: "absolute inset-2.5 overflow-hidden rounded-[4px] shadow-[0_0_6px_rgba(0,0,0,0.15)] flex flex-col bg-white transition-all duration-200 [transition-timing-function:cubic-bezier(0.645,0.045,0.355,1)]" + dragClass,
    style: style
  });
}

function AttachmentFormSection$Ui$MainImageLabel(props) {
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: "absolute left-[-24px] top-[15px] z-[15] flex h-[22px] w-[100px] rotate-[-45deg] items-center justify-center bg-tan-gold-light text-[13px] font-light uppercase text-white"
  });
}

function AttachmentFormSection$Ui$AddFileItemWrapper(props) {
  return JsxRuntime.jsx("li", {
    children: props.children,
    className: "w-1/3 max-sm:w-1/2"
  });
}

function AttachmentFormSection$Ui$AddFileItemInner(props) {
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: "relative h-0 pb-[95%]"
  });
}

function AttachmentFormSection$Ui$AddFileItemInnerContent(props) {
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: "absolute inset-2.5 flex flex-col items-center justify-center rounded-[4px] border border-zinc-300 bg-white text-zinc-500"
  });
}

function AttachmentFormSection$FileBar(props) {
  let onDeleteAttachment = props.onDeleteAttachment;
  return JsxRuntime.jsxs(AttachmentFormSection$Ui$FileBarWrapper, {
    children: [
      JsxRuntime.jsxs(AttachmentFormSection$Ui$FileNameWrapper, {
        children: [
          JsxRuntime.jsx(AttachmentFormSection$Ui$FileOrder, {
            children: (props.index + 1 | 0).toString()
          }),
          JsxRuntime.jsx(AttachmentFormSection$Ui$FileName, {
            children: props.fileName
          })
        ]
      }),
      JsxRuntime.jsx(AttachmentFormSection$Ui$RemoveButtonWrapper, {
        onClick: param => onDeleteAttachment(),
        children: JsxRuntime.jsx(IconV5.make, {
          icon: "trash"
        })
      })
    ]
  });
}

function AttachmentFormSection$AttachmentContent(props) {
  let content = props.content;
  let tmp;
  if (typeof content !== "object") {
    tmp = JsxRuntime.jsx(IconV5.make, {
      icon: "file-pdf",
      size: 60
    });
  } else if (content.TAG === "Error") {
    tmp = JsxRuntime.jsxs(AttachmentFormSection$Ui$ErrorContent, {
      children: [
        JsxRuntime.jsx(IconV5.make, {
          icon: "error",
          size: 40
        }),
        JsxRuntime.jsx(AttachmentFormSection$Ui$ErrorContentTitle, {
          children: content._0
        })
      ]
    });
  } else {
    let preview = content._0;
    tmp = preview !== undefined ? JsxRuntime.jsx(AttachmentFormSection$Ui$ImageContent, {
        src: preview,
        alt: ""
      }) : JsxRuntime.jsx(IconV5.make, {
        icon: "image",
        size: 70
      });
  }
  return JsxRuntime.jsx(AttachmentFormSection$Ui$AttachmentItemContent, {
    children: tmp
  });
}

function AttachmentFormSection$AttachmentItem(props) {
  let isImage = props.isImage;
  let error = props.error;
  let content = error !== undefined ? ({
      TAG: "Error",
      _0: error
    }) : (
      isImage ? ({
          TAG: "Image",
          _0: props.previewUrl
        }) : "File"
    );
  return JsxRuntime.jsxs(AttachmentFormSection$Ui$AttachmentItem, {
    uploaded: props.isUploaded,
    draggable: isImage,
    children: [
      props.isMain && isImage ? JsxRuntime.jsx(AttachmentFormSection$Ui$MainImageLabel, {
          children: "Main"
        }) : null,
      JsxRuntime.jsx(AttachmentFormSection$AttachmentContent, {
        content: content
      }),
      JsxRuntime.jsx(AttachmentFormSection$FileBar, {
        index: props.index,
        fileName: props.fileName,
        onDeleteAttachment: props.onDeleteAttachment
      })
    ]
  });
}

function type_(param) {
  return "ATTACHMENT";
}

let Item = {
  type_: type_
};

let ReactDnd$1 = ReactDnd.Make(Item);

function collect(monitor, _props) {
  let isDragging = ReactDnd$1.DragSourceMonitor.isDragging(monitor);
  return {
    isDragging: isDragging
  };
}

function AttachmentFormSection$UploadStatus(props) {
  let uploadDone = props.uploadDone;
  let reorder = props.reorder;
  let id = props.id;
  let isImage = props.isImage;
  let index = props.index;
  let domRef = React.useRef(null);
  let match = ReactDnd$1.useDrag(undefined, collect, {
    id: id,
    index: index
  }, undefined);
  let match$1 = ReactDnd$1.useDrop(undefined, (extra, extra$1) => {
    let dragIndex = extra.index;
    let match = ReactDnd$1.DropTargetMonitor.getClientOffset(extra$1);
    let match$1 = domRef.current;
    if (match === undefined) {
      return;
    }
    if (match$1 == null) {
      return;
    }
    let hoverBoundingRect = match$1.getBoundingClientRect();
    let hoverMiddleX = ((hoverBoundingRect.right | 0) - (hoverBoundingRect.left | 0) | 0) / 2 | 0;
    let hoverClientX = match.x - (hoverBoundingRect.left | 0) | 0;
    let isDraggingRight = dragIndex < index && hoverClientX < hoverMiddleX;
    let isDraggingLeft = dragIndex > index && hoverClientX > hoverMiddleX;
    if (isDraggingLeft || isDraggingRight) {
      return reorder(extra.id, id);
    }
  }, "ATTACHMENT", undefined);
  if (isImage) {
    match$1[1](match[1](domRef));
  }
  let opacity = match[0].isDragging ? 0 : 1;
  return JsxRuntime.jsx(AttachmentFormSection$Ui$UploadStatusItem, {
    opacity: opacity,
    innerRef: Primitive_option.some(domRef),
    children: JsxRuntime.jsxs(AttachmentFormSection$Ui$UploadStatusItemInner, {
      children: [
        JsxRuntime.jsx(AttachmentFormSection$AttachmentItem, {
          error: props.error,
          fileName: props.fileName,
          index: index,
          isUploaded: uploadDone,
          isImage: isImage,
          isMain: props.isMain,
          onDeleteAttachment: props.onDeleteAttachment,
          previewUrl: props.previewUrl
        }),
        uploadDone ? null : JsxRuntime.jsx(AttachmentFormSection$Ui$UploadIndicatorWrapper, {
            children: JsxRuntime.jsx(UploadProgressIndicator.make, {
              progress: props.progress * 100
            })
          })
      ]
    })
  });
}

function AttachmentFormSection$AddFileItem(props) {
  return JsxRuntime.jsx(AttachmentFormSection$Ui$AddFileItemWrapper, {
    children: JsxRuntime.jsx(AttachmentFormSection__FileInputLink.make, {
      onChange: props.onChange,
      multiple: props.multiple,
      children: props.children
    })
  });
}

function AttachmentFormSection$UploadList(props) {
  let uploads = props.uploads;
  let showAddFile = props.showAddFile;
  let reorder = props.reorder;
  let onUploadStatusChange = props.onUploadStatusChange;
  let onDeleteAttachment = props.onDeleteAttachment;
  let isImage = props.isImage;
  let isUploading = Stdlib_Option.mapOr(uploads.find(attachment => {
    let match = attachment.state;
    return match.TAG === "InProgress";
  }), false, param => true);
  React.useEffect(() => {
    if (onUploadStatusChange !== undefined) {
      onUploadStatusChange(isUploading);
    }
  }, [isUploading]);
  let hasContent = uploads.length !== 0 || showAddFile;
  return JsxRuntime.jsxs(AttachmentFormSection$Ui$UploadList, {
    isImage: isImage,
    hasContent: hasContent,
    children: [
      uploads.map((u, i) => {
        let match = u.state;
        let error;
        error = match.TAG === "Failed" ? "upload failed" : undefined;
        let match$1 = u.state;
        let isUploaded;
        isUploaded = match$1.TAG === "Success";
        let match$2 = u.state;
        let progress;
        switch (match$2.TAG) {
          case "InProgress" :
            progress = match$2._1;
            break;
          case "NotStarted" :
          case "Failed" :
            progress = 0;
            break;
          case "Success" :
            progress = 1;
            break;
        }
        let isMain = isImage && i === 0;
        return JsxRuntime.jsx(AttachmentFormSection$UploadStatus, {
          error: error,
          fileName: Attachments.Attachment.fileName(u),
          index: i,
          isImage: isImage,
          isMain: isMain,
          onDeleteAttachment: () => onDeleteAttachment(Attachments.Attachment.id(u)),
          id: Attachments.Attachment.id(u),
          previewUrl: u.previewUrl,
          progress: progress,
          reorder: reorder,
          uploadDone: isUploaded
        }, Attachments.Attachment.id(u));
      }),
      showAddFile ? JsxRuntime.jsx(AttachmentFormSection$AddFileItem, {
          multiple: true,
          onChange: props.onAddAttachments,
          children: JsxRuntime.jsx(AttachmentFormSection$Ui$AddFileItemInner, {
            children: JsxRuntime.jsxs(AttachmentFormSection$Ui$AddFileItemInnerContent, {
              children: [
                JsxRuntime.jsx(IconV5.make, {
                  icon: "add",
                  size: 46,
                  className: "h-[46px] w-[46px] max-sm:h-[36px] max-sm:w-[36px] mt-[15px] mb-[18px] max-sm:mb-4"
                }),
                JsxRuntime.jsx("span", {
                  children: "Add file",
                  className: "text-[20px]"
                })
              ]
            })
          })
        }) : null
    ]
  });
}

function AttachmentFormSection$FileUploadList(props) {
  return JsxRuntime.jsx(AttachmentFormSection$UploadList, {
    isImage: false,
    onAddAttachments: props.onAddAttachments,
    onDeleteAttachment: props.onDeleteAttachment,
    onUploadStatusChange: props.onUploadStatusChange,
    reorder: props.reorder,
    showAddFile: false,
    uploads: props.uploads
  });
}

let FileUploadList = {
  make: AttachmentFormSection$FileUploadList
};

function AttachmentFormSection$ImageUploadList(props) {
  return JsxRuntime.jsx(AttachmentFormSection$UploadList, {
    isImage: true,
    onAddAttachments: props.onAddAttachments,
    onDeleteAttachment: props.onDeleteAttachment,
    onUploadStatusChange: props.onUploadStatusChange,
    reorder: props.reorder,
    showAddFile: true,
    uploads: props.uploads
  });
}

let ImageUploadList = {
  make: AttachmentFormSection$ImageUploadList
};

function AttachmentFormSection(props) {
  let updateFiles = props.updateFiles;
  let updateImages = props.updateImages;
  let filesResult = props.filesResult;
  let imagesResult = props.imagesResult;
  let files = props.files;
  let images = props.images;
  let imagesList = Stdlib_List.fromArray(images);
  let filesList = Stdlib_List.fromArray(files);
  let updateImages$1 = v => updateImages(Stdlib_List.toArray(v));
  let updateFiles$1 = v => updateFiles(Stdlib_List.toArray(v));
  let onUnsupportedFileError = Attachments.useUnsupportedFilesSystemMessage();
  let i = Attachments.useAttachments(updateImages$1, imagesList, onUnsupportedFileError);
  let f = Attachments.useAttachments(updateFiles$1, filesList, onUnsupportedFileError);
  let imageUploadInProgress = AttachmentFormUtils.anyInProgress(images);
  let fileUploadInProgress = AttachmentFormUtils.anyInProgress(files);
  let add = extra => {
    let addImages = i.add;
    let addFiles = f.add;
    let match = Belt_Array.partition(extra, file => Attachments.Attachment.ContentType.isImage(file.type));
    let files = match[1];
    let images = match[0];
    if (images.length !== 0) {
      addImages(images);
    }
    if (files.length !== 0) {
      return addFiles(files);
    }
  };
  let match = i.attachments.concat(f.attachments);
  let tmp;
  let exit = 0;
  if (filesResult !== undefined && !(filesResult.TAG === "Ok" || fileUploadInProgress)) {
    tmp = JsxRuntime.jsx(Form.$$Error.make, {
      children: filesResult._0
    });
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = imagesResult !== undefined && !(imagesResult.TAG === "Ok" || imageUploadInProgress) ? JsxRuntime.jsx(Form.$$Error.make, {
        children: imagesResult._0
      }) : null;
  }
  let match$1 = AttachmentFormUtils.anyInProgress(images);
  let match$2 = AttachmentFormUtils.anyInProgress(files);
  let tmp$1;
  let exit$1 = 0;
  if (match$1 || match$2) {
    exit$1 = 1;
  } else {
    tmp$1 = null;
  }
  if (exit$1 === 1) {
    tmp$1 = JsxRuntime.jsx(View__Jsx3.make, {
      mt: {
        NAME: "px",
        VAL: "p10"
      },
      children: "Uploading..."
    });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(DragDrop.DragDropContext.make, {
        children: JsxRuntime.jsx(DragDrop.DropArea.make, {
          onChange: add,
          children: match.length !== 0 ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(AttachmentFormSection$ImageUploadList, {
                  onAddAttachments: add,
                  onDeleteAttachment: i.delete,
                  reorder: i.reorder,
                  uploads: i.attachments
                }),
                JsxRuntime.jsx(AttachmentFormSection$FileUploadList, {
                  onAddAttachments: add,
                  onDeleteAttachment: f.delete,
                  reorder: f.reorder,
                  uploads: f.attachments
                })
              ]
            }) : JsxRuntime.jsx(InitialUploadPrompt.make, {
              onAddAttachments: add
            })
        })
      }),
      tmp,
      tmp$1
    ]
  });
}

let make = AttachmentFormSection;

exports.make = make;
exports.ImageUploadList = ImageUploadList;
exports.FileUploadList = FileUploadList;
/* ReactDnd Not a pure module */
